import loadable from '@loadable/component';

const PostPage = loadable(() => import('./PostPage'));

export { PostPage };
